<template>
    <div>
        <div class="card-header">
            <h3>{{ $t("lang.label_currency") }}</h3>
        </div>
        <div class="card-body" style="min-height: 200px">
            <div class="row">
                <form @submit.prevent="SaveForm()" style="width: 100%">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>{{ $t("lang.label_name") }}:</label>
                            <div class="input-group">
                                <select class="form-control" v-model="reg.currency_id">
                                    <option
                                        v-for="(i, index) in dat"
                                        :key="index"
                                        v-bind:value="i.id"
                                    >
                                        {{ i.name }} ({{ i.cod }}) {{ i.symb }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        type="submit"
                                        class="btn btn-info"
                                        :disabled="btnSave"
                                    >
                                        <i class="fas fa-save fa-ms"></i>
                                        {{ $t("lang.label_save") }}
                                    </button>
                                    <a
                                        class="btn btn-add-group"
                                        @click="closeModal"
                                        style="margin-left: 10px; color: inherit;"
                                    >
                                        {{ $t("lang.label_cancel") }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "currency",
    data () {
        return {
            btnSave: false,
            dat: [],
            reg: {
                id: null,
                currency_id: null,
                user_id: window.localAccountID,
                org_id: window.localuserdata,
            },
        }
    },
    created () {
        this.GetCurrency();
    },
    methods: {
        SaveForm() {
            this.btnSave = true;
            this.isLoading = true;
            this.$swal({
                type: "success",
                title: window.lang2.label_save_currency,
                timer: 1000,
            }).then((response) => {
                if (this.reg.currency_id > 0) {
                    let url = "/menu/information/AddCurrency";
                    if (this.reg.id > 0) {
                        url = "/menu/information/EditCurrency";
                    }
                    window.master
                        .post(url, this.reg)
                        .then((response) => {
                            console.log(response.data);
                            localStorage.setItem("currency", response.data.currency);
                            this.btnSave = false;
                            this.closeModal();
                        })
                        .catch((error) => {
                            this.btnSave = false;
                            this.closeModal();
                            console.log(error);
                        });
                }
            });
        },
        GetCurrency() {
            window.master
                .get(
                    "/menu/information/GetCurrency/" +
                        window.localAccountID +
                        "/" +
                        window.localuserdata
                )
                .then((response) => {
                    let r = response.data.c;
                    let k = response.data.currency;
                    this.dat = r;
                    let g = Array();
                    for (let i = 0; i < r.length; i++) {
                        if (r[i].symb === k) {
                            g.push({
                                id: r[i].id,
                            });
                        }
                    }
                    this.reg.currency_id = g[0].id;
                    console.log("GetCurrency", response.data);
                    let y = JSON.stringify(response.data.b);
                    if (y === "null" || y === null) {
                        this.reg.id = null;
                    } else {
                        this.reg.id = response.data.a.id;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeModal() {
            this.$modal.hide("modal-setting");
        },
    },
}
</script>
<style lang="scss" scoped>
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
</style>
